import React, { useState, useEffect, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { disableHTMLOverflow } from '../Functions';
import { withCookies } from 'react-cookie';
import { getWSService } from './../js/WebSocketService';
import { useRef } from 'react';

function AWSSignal({ history, show }) {
    const [ariaHidden, setAriaHidden] = useState(!show);
    const AWSSignalLost = 60;

    let intervalId = useRef();

    const AWSMessageHandler = useCallback(evt => {
        if (evt) {
            clearInterval(intervalId.current);
            intervalId.current = setInterval(() => {
                setAriaHidden(false);
            }, AWSSignalLost * 1000); //60 * 1000 = 60000ms = 1min
        }
    }, []);

    const MensajeWebSocket = msg => {
        var obj = {};
        obj.type = 'ping';
        obj.data = msg;
        return obj;
    };

    const sendMessageAWS = useCallback(() => {
        var model = {};
        getWSService().sendMessage('onMessage', MensajeWebSocket(model));
    }, []);

    useEffect(() => {
        getWSService().addMessageListener('ping', 'ping', AWSMessageHandler);
    }, [AWSMessageHandler]);

    useEffect(() => {
        let intervalIdAWS = setInterval(() => {
            sendMessageAWS();
        }, AWSSignalLost * 500); // 60 * 500 = 30000ms = 30s

        return () => clearInterval(intervalIdAWS);
    }, [sendMessageAWS]);

    const closeThisModal = () => {
        disableHTMLOverflow(false);
        setAriaHidden(true);
        window.location.reload();
    };

    return (
        <div
            className="c-modal c-modal--same-bid"
            aria-hidden={ariaHidden}
            id="modal-amazon-connection-lost"
        >
            <div
                className="c-modal__overlay  js-modal-close"
                tabIndex="-1"
            ></div>
            <div
                className="c-modal__wrapper"
                role="dialog"
                aria-labelledby="modal-amazon-connection-lost-title"
            >
                <header className="c-modal__header">
                    <div className="c-modal__title__wrapper">
                        <h1
                            className="c-modal__title"
                            id="modal-amazon-connection-lost-title"
                        >
                            Vaya...
                        </h1>
                    </div>
                </header>
                <div className="c-modal__content" role="document">
                    <p className="u-mt-large">
                        Parece que has perdido conexión con Amazon, por favor
                        refresca la página para continuar!
                    </p>
                </div>
                <div className="c-modal__footer">
                    <div className="c-modal__actions">
                        <div className="c-modal__actions__item">
                            <button
                                className={'c-btn js-modal-close'}
                                aria-label="Baneado"
                                onClick={closeThisModal}
                            >
                                <span className="c-btn__text">Actualizar</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withCookies(withRouter(AWSSignal));
